<template>
	<div class="flex flex-col gap-2 rounded-md border border-won-gray-light bg-won-sand-light p-2">
		<span class="text-[12px] font-medium text-won-secondary">Alignment is temporarily unavailable</span>

		<p class="text-[14px] text-won-black">
			We couldn't check your resume against your target role just now. Your other scores are up to date, and
			your total is out of 60 until Alignment is back. Try again in a few minutes.
		</p>
	</div>
</template>

<script setup>
// EN-1113: alignment_status `unavailable`. The AI provider failed while scoring Alignment,
// so it wasn't computed. The server holds this for two minutes, then scores it again.
</script>
